module.exports = __webpack_public_path__ + "img/roundtrip-banner-small.a3a13e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/roundtrip-banner-small.png
// module id = 276
// module chunks = 0